import { Action, getModule, Module, VuexModule } from 'vuex-module-decorators';
import store from '@/store'

import { StoreOperation } from '@/entity/warehouse/Operations/OperationsMove'
import {ResponseDataType} from "@/form/form.types";
@Module({
    namespaced: true,
    name: 'operationsMove',
    store,
    dynamic: true,
})
class OperationsMoveModule extends VuexModule {
    @Action({rawError: true})
    async create(data: StoreOperation): Promise<ResponseDataType> {
        return await store.$repository.operationsMove.OperationAction(data)
    }
}
export const OperationsMoveStore = getModule(OperationsMoveModule)